export enum ActivitiesRowVariant {
  STANDARD = 'STANDARD',
  BORDERED = 'BORDERED'
}
